import { render } from "./Rejected.vue?vue&type=template&id=566c732c"
import script from "./Rejected.vue?vue&type=script&lang=js"
export * from "./Rejected.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__